import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { salesforceObjectMetadata } from './salesforce-object-metadata';
import { format } from 'app/shared/utils/string.util';
import { getConnectorV1Name, getConnectorV2Name } from 'shell-models-lib';

export const salesforceServiceCloudObjectMetadata: IDatasetTypeMetadata = {
    ...salesforceObjectMetadata,
    type: adfModelTypeMap.salesforceServiceCloud.datasetType,
    displayName: getConnectorV1Name(stringResources.SalesforceServiceCloudObject_DisplayText),
    supportLinkedServiceTypes: [adfModelTypeMap.salesforceServiceCloud.linkedServiceType],
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.DatasetLowerCase,
        getConnectorV2Name(stringResources.SalesforceServiceCloudObject_DisplayText)
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-salesforce-service-cloud?tabs=data-factory',
};
